// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2ZBjvClsdDrboWvwrw98vv_0","card":"ct7KNX1ZdM2Ag73GeK05R_0","info":"lmAPuR9D2W3zY7XJmHmUN_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5d67218","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.common/ui/role-assignment.vue
// module id = 230
// module chunks = 0